/**
 * NED-4397 — staleness test for a `matrix:session-invalidated` flag/event.
 *
 * An invalidation is "superseded" when it belongs to an OLDER session than the
 * one currently active — i.e. its stamped `loginNonce` is strictly less than the
 * current login nonce. Such an invalidation must be ignored (no modal, no
 * auth-teardown), because a newer login has already established a valid session.
 *
 * IMPORTANT — fail-safe toward logout:
 *  - The comparison is STRICT `<`. An invalidation stamped with the CURRENT nonce
 *    (`=== currentNonce`) is a genuine invalidation of the live session and must
 *    NOT be treated as superseded (it must still show the modal / log out).
 *    Never relax this to `<=` — that would suppress a real logout.
 *  - A missing / non-numeric `loginNonce` (e.g. an un-stamped invalidation from an
 *    older build, or a malformed flag) is treated as NOT superseded → shown/torn
 *    down. Only a value that is provably older is ever suppressed.
 *
 * @param {*} parsed - the parsed flag JSON or the CustomEvent `detail`.
 * @param {number} currentNonce - matrixAuthService.getLoginNonce().
 * @returns {boolean} true only when `parsed.loginNonce` is a number strictly < currentNonce.
 */
export function isSupersededInvalidation(parsed, currentNonce) {
  return (
    typeof currentNonce === 'number'
    && typeof parsed?.loginNonce === 'number'
    && parsed.loginNonce < currentNonce
  );
}
